/**
 * Created by Victor Rojo on 8/10/18.
 */
import {Component, Input, IterableDiffers, DoCheck, OnDestroy } from '@angular/core';

import {Widget, WidgetTypes, StatusLevels, WidgetStatusLine} from "../../widget/Widget";
import {WidgetService} from "../../widget/Widget.service";
import {StatusNotificationService} from "../../statusNotification/StatusNotification.service";
import {NotificationMessageService} from "../../notificationMessage/NotificationMessage.service";
import {NotificationMessage} from "../../notificationMessage/NotificationMessage";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";


@Component({
  selector: 'widget-status-footer',
  templateUrl: './WidgetStatusFooter.component.html',
  styleUrls: ['./WidgetStatusFooter.component.css']
})
export class WidgetStatusFooterComponent {
  private _widget: Widget;
  private differ: any;
  private markForDeleteTimeouts:any[] = [];
  private statusLevelOkId: number;
  private StatusLevels: any;
  collapsed:boolean = true;
  statusNotifications:WidgetStatusLine[] = [];
  notificationMessages:NotificationMessage[] = [];

  constructor(private statusNotificationService:StatusNotificationService,
              private notificationMessageService: NotificationMessageService,
              differs: IterableDiffers) {
    this.differ = differs.find([]).create(null);
    this.statusLevelOkId = StatusLevels.OK;
    this.StatusLevels = StatusLevels;
  }

  get widget(): Widget {
    return this._widget;
  }

  @Input()
  set widget(widget: Widget) {
    this._widget = widget;
    this.updateStatusNotifications();
    this.reloadLastNotifications();
  }

  toogleCollapsed(){
    this.collapsed = !this.collapsed;
    this.updateStatusNotifications();
    if ( !this.collapsed ) {
      this.reloadLastNotifications();
    }
  }

  private updateStatusNotifications(){
    if ( this.collapsed ) {
      this.statusNotifications = this._widget.widgetStatusList ? this._widget.widgetStatusList.slice(0,1) : [];
    } else {
      this.statusNotifications = this._widget.widgetStatusList;
    }
  }

  markForDelete(statusNotification:any){
    statusNotification.confirmDelete = true;
    this.markForDeleteTimeouts[statusNotification.statusNotificationId] = setTimeout(()=>{
      statusNotification.confirmDelete = false;
    }, 30000);
  }

  onSolvedDescriptionKeyUp(statusNotification:any){
    clearTimeout(this.markForDeleteTimeouts[statusNotification.statusNotificationId]);
    this.markForDeleteTimeouts[statusNotification.statusNotificationId] = setTimeout(()=>{
      statusNotification.confirmDelete = false;
    }, 30000);
  }

  solveStatusNotification(statusNotification:any) {
    clearTimeout(this.markForDeleteTimeouts[statusNotification.statusNotificationId]);
    statusNotification.solving = true;
    this.statusNotificationService.solveStatusNotification(statusNotification.statusNotificationId, statusNotification.solvedDescription)
      .then(response => {
        statusNotification.solving = false;
        this.reloadLastNotifications();
      });
  }

  ngDoCheck() {
    const change = this.differ.diff(this._widget.widgetStatusList);
    if ( change ) {
      this.updateStatusNotifications();
    }
  }

  reloadLastNotifications(){
    this.notificationMessageService.getLastWidgetNotifications(this._widget.widgetId)
      .then(notificationMessages => {
        this.notificationMessages = notificationMessages;
      })
  }
}
